import { createStore, applyMiddleware } from "redux";
import  rootReducer  from "./reducer";
import thunk from "redux-thunk";

import { alert } from './alertReducer';

import { authentication } from './authentication';
//import {routerMiddleware, syncHistoryWithStore, routerReducer} from 'react-router-redux';
import {createHashHistory} from 'history';

//let hashHistory = createHashHistory()
//const router = routerMiddleware(hashHistory);




const enhancer = applyMiddleware(thunk);
const store = createStore(
  rootReducer,enhancer
  
);
//const history = syncHistoryWithStore(hashHistory, store);

export default  store;